/**
 * Device Detector Based on Stingray Cookie
 *
 * @module app/components/DeviceDetector
 */
import docCookies from 'doc-cookies';
import semver from 'semver';
import MessageBusTopics from '../../common/MessageBusTopics';

/*jshint camelcase: false */
var data = {
    cookieName: 'wh_device',
    constant: {
        platform: {
            ios: 'ios',
            android: 'android',
            desktop: 'desktop',
            macos: 'macos',
        },
        device: {
            mobile: 'mobile',
            tablet: 'tablet',
            desktop: 'desktop',
        },
        channel: {
            native: 'native',
            web: 'web',
        },
    },
    //  default cookie
    cookieValue: {
        device_os: 'desktop',
    },
    toBoolean: function toBoolean(value) {
        if (typeof value === 'string') {
            value = value === 'true';
        }

        return value;
    },
    toNumber: function toNumber(value) {
        var number = parseFloat(value);
        return isNaN(number) ? null : number;
    },
    validateSemver: function (value){
        return semver.valid(semver.coerce(String(value)));
    },
    // lowercase and parse cookie value
    getCookieValue: function getCookieValue() {
        if (docCookies.hasItem(this.cookieName)) {
            var value = docCookies.getItem(this.cookieName);
            this.cookieValue = JSON.parse(value.toLowerCase());
        }
    },
    getDevice: function getDevice() {
        const name = this.constant.device;
        const platform = this.constant.platform;
        let device = this.toBoolean(this.cookieValue.is_tablet) ? name.tablet : name.mobile;

        if (
            !this.cookieValue.device_os ||
            this.cookieValue.device_os === name.desktop ||
            this.cookieValue.device_os === platform.macos
        ) {
            device = name.desktop;
        }
        return device;
    },
    getOS: function getOS() {
        return this.cookieValue.device_os;
    },
    isNative: function isNative() {
        return this.toBoolean(this.cookieValue.is_native);
    },
    getPlatform: function getPlatform() {
        return this.isNative() ? this.constant.channel.native : this.constant.channel.web;
    },
    getVersion: function getVersion() {
        return this.validateSemver(this.cookieValue.os_version);
    },
    getAppVersion: function getAppVersion() {
        return this.validateSemver(this.cookieValue.app_version);
    },
    getJurisdiction: function getJurisdiction() {
        return window.whStatic.config.jurisdiction.split('.').pop();
    },
    getEnvironment: function getEnvironment() {
        return window.whStatic.config.environment;
    },
    getAll: function getAll() {
        this.result = {
            device: this.getDevice(),
            os: this.getOS(),
            platform: this.getPlatform(),
            version: this.getVersion(),
            appVersion: this.getAppVersion(),
            jurisdiction: this.getJurisdiction(),
            environment: this.getEnvironment(),
        };
        return this.result;
    },
    publish: function publish() {
        if (window.WH && window.WH.messageBus && window.WH.messageBus.publishSticky) {
            window.WH.messageBus.publishSticky(
                MessageBusTopics.DEVICE_DETECTOR_DEVICE_DATA,
                this.check.getResult()
            );
        }
    },
    init: function init() {
        this.getCookieValue();
        this.getAll();
        this.publish();
    },
    check: {
        isMobile: function isMobile() {
            return data.result.device === data.constant.device.mobile;
        },
        isTablet: function isTablet() {
            return data.result.device === data.constant.device.tablet;
        },
        isDesktop: function isDesktop() {
            return data.result.device === data.constant.device.desktop;
        },
        isIOS: function isIOS() {
            return data.result.os === data.constant.platform.ios;
        },
        isAndroid: function isAndroid() {
            return data.result.os === data.constant.platform.android;
        },
        isNative: function isNative() {
            return data.isNative();
        },
        isNativeCom: function isNativeCom() {
            return data.isNative() && data.getJurisdiction() === 'com';
        },
        isNativeSpain: function isNativeSpain() {
            return data.isNative() && data.getJurisdiction() === 'es';
        },
        isInternational: function isInternational() {
            return data.getJurisdiction() === 'it' || data.getJurisdiction() === 'es';
        },
        isIPhone: function isIPhone() {
            return this.isMobile() && this.isIOS();
        },
        isNativeAndroid: function isNativeAndroid() {
            return this.isNative() && this.isAndroid();
        },
        isNativeiOS: function isNativeiOS() {
            return this.isNative() && this.isIOS();
        },
        getDeviceOs: function getDeviceOs() {
            return data.result.os;
        },
        getAppVersion: function getAppVersion() {
            return data.result.appVersion;
        },
        getOsVersion: function getOsVersion() {
            return data.result.version;
        },
        getPlatformCode: function getPlatformCode() {
            return {
                platform: data.result.os,
                channel: data.result.platform,
            };
        },
        getDeviceType: function getDeviceType() {
            return data.result.device;
        },
        deviceDetectionAvailable: function deviceDetectionAvailable() {
            return !!data.cookieValue;
        },
        getResult: function getResult() {
            return data.result;
        },
        getApi: function getApi() {
            return data;
        },
    },
};

data.init();

export default data.check;
